


















import LatestEntriesCardEmpty from "@/components/cards/LatestEntriesCardEmpty.vue";
import TheLayoutPortal from "@/layouts/TheLayoutPortal.vue";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import { buildTemplate, ITemplate } from "@/models/template.entity";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { AdminTemplateModule } from "@/store/modules/admin-template.store";
import { PartnerTemplateModule } from "@/store/modules/partner-template.store";
import TemplateDetailForm from "@/components/template/TemplateDetailForm.vue";

@Component({
  components: {
    TheLayoutPortal,
    TemplateDetailForm,
    LatestEntriesCardEmpty
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class AdminTemplateDetailFormView extends mixins(PartnerFallbackMixin) {
  isLoading = false;

  template: ITemplate | null = null;

  get partnerId(): string {
    return this.$route.params.partnerId;
  }

  get templateId(): string {
    return this.$route.params.templateId;
  }

  get store() {
    if (!this.partnerId) return PartnerTemplateModule;
    return AdminTemplateModule;
  }

  async mounted() {
    await this.trySetByRouteOrDefault();

    const template =
      this.store.maps.id.get(this.templateId)[0] ??
      buildTemplate({
        id: this.templateId,
        partnerId: this.partnerId
      });

    try {
      this.isLoading = true;
      await template.fetch();
      this.template = template;
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoading = false;
    }
  }
}
